/**
 * @generated SignedSource<<9ac0a526066101108675c67f2a2c074c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type trendsDetailRefetchQuery$variables = {
  id: string;
};
export type trendsDetailRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"trendsDetail_QueryFragment">;
};
export type trendsDetailRefetchQuery = {
  response: trendsDetailRefetchQuery$data;
  variables: trendsDetailRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "heading",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v10 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v12 = [
  (v4/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTaxFree",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "netPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v9/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deGrossPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "atGrossPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "chGrossPrice",
              "storageKey": null
            }
          ],
          "type": "AcademiesProductExtension",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "licenseAvailability",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numAvailable",
          "storageKey": null
        }
      ],
      "type": "LicenseAvailabilityFreeLicensesAvailable",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CoachingOfferDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AcademiesTagData",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbnail",
            "storageKey": null
          },
          (v7/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v13/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "setting",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v9/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CoachProfile",
    "kind": "LinkedField",
    "name": "associatedCoaches",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "coach",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "storageKey": null
  },
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "typeDefinition",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "extension",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isUnlockNecessaryToStart",
                  "storageKey": null
                }
              ],
              "type": "LearnContentExtensionImpl",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LearnAsyncContentTypeDefinition",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressPercentage",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headContentId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isClickable",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopic",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "AcademiesTagData",
  "kind": "LinkedField",
  "name": "data",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "unlockInfo",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v9/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstContentId",
                  "storageKey": null
                }
              ],
              "type": "UnlockInfoDemo",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diploma",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v9/*: any*/),
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "extension",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isMicroLearning",
                  "storageKey": null
                },
                (v14/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContractPartner",
                  "kind": "LinkedField",
                  "name": "contractPartner",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContractPartnerData",
                      "kind": "LinkedField",
                      "name": "data",
                      "plural": false,
                      "selections": (v12/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "PublishedConstellationRootExtensionExtension",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PublishedRootExtensionImpl",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "trendsDetailRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "trendsDetail_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "trendsDetailRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TrendData",
                "kind": "LinkedField",
                "name": "trendData",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Advantage",
                    "kind": "LinkedField",
                    "name": "advantages",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "trendMedia",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "file",
                    "plural": false,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerData",
                "kind": "LinkedField",
                "name": "customerData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amountCustomer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerFeedback",
                    "kind": "LinkedField",
                    "name": "customerFeedbacks",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "feedback",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "position",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HeadingAndDescription",
                "kind": "LinkedField",
                "name": "aboutOffersHeadingAndDescription",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HeadingAndDescription",
                "kind": "LinkedField",
                "name": "potentialAnalysisHeadingAndDescription",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HeadingAndDescription",
                "kind": "LinkedField",
                "name": "coachingHeadingAndDescription",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "coachingImage",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "learnables",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isPublishedLearnable"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoachingOffer",
                        "kind": "LinkedField",
                        "name": "groupCoaching",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "PublishedGroupCoachingLearnable",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoachingOffer",
                        "kind": "LinkedField",
                        "name": "oneToOneCoaching",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "PublishedOneToOneCoachingLearnable",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v11/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "viewerTreeState",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v20/*: any*/),
                                          (v21/*: any*/)
                                        ],
                                        "type": "IsStartedViewerTreeState",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v25/*: any*/)
                                ],
                                "type": "LearnOpportunityRootStructureDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PublishedCourseLearnable",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v11/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "viewerTreeState",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*: any*/),
                                          (v20/*: any*/)
                                        ],
                                        "type": "IsStartedViewerTreeState",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v25/*: any*/)
                                ],
                                "type": "LearnOpportunityRootStructureDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PublishedMicroLearningLearnable",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Trend",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AcademiesTagQueries",
        "kind": "LinkedField",
        "name": "AcademiesTag",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AcademiesRootTagsConnection",
            "kind": "LinkedField",
            "name": "AcademiesTags",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AcademiesRootTagsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AcademiesRootTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canBeDeleted",
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AcademiesChildTagsConnection",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AcademiesChildTagsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AcademiesChildTag",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AcademiesTagData",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/),
                                      (v22/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subId",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "84d8de195ffa687571f5016aae768703",
    "id": null,
    "metadata": {},
    "name": "trendsDetailRefetchQuery",
    "operationKind": "query",
    "text": "query trendsDetailRefetchQuery(\n  $id: ID!\n) {\n  ...trendsDetail_QueryFragment_1Bmzm5\n}\n\nfragment coachingLearnableCard_PublishedLearnableFragment on PublishedLearnable {\n  __isPublishedLearnable: __typename\n  ... on PublishedGroupCoachingLearnable {\n    kind\n    id\n    groupCoaching {\n      id\n      description {\n        name\n        description\n        shortDescription\n        tags {\n          __typename\n          id\n          data {\n            name\n          }\n        }\n        image {\n          thumbnail\n          url\n          id\n        }\n        product {\n          ...offerCard_ProductFragment\n          id\n        }\n      }\n      setting {\n        __typename\n        kind\n      }\n      associatedCoaches {\n        coach {\n          name\n          id\n        }\n        id\n      }\n      licenseAvailability {\n        __typename\n        ... on LicenseAvailabilityFreeLicensesAvailable {\n          numAvailable\n        }\n      }\n    }\n  }\n  ... on PublishedOneToOneCoachingLearnable {\n    kind\n    id\n    oneToOneCoaching {\n      id\n      description {\n        name\n        description\n        shortDescription\n        tags {\n          __typename\n          id\n          data {\n            name\n          }\n        }\n        image {\n          thumbnail\n          url\n          id\n        }\n        product {\n          ...offerCard_ProductFragment\n          id\n        }\n      }\n      setting {\n        __typename\n        kind\n      }\n      associatedCoaches {\n        coach {\n          name\n          id\n        }\n        id\n      }\n      licenseAvailability {\n        __typename\n        ... on LicenseAvailabilityFreeLicensesAvailable {\n          numAvailable\n        }\n      }\n    }\n  }\n}\n\nfragment educationalOfferCard_PublishedCourseLearnableFragment on PublishedLearnable {\n  __isPublishedLearnable: __typename\n  ... on PublishedCourseLearnable {\n    id\n    kind\n    root {\n      id\n      description\n      shortDescription\n      image {\n        url\n        id\n      }\n      typeDefinition {\n        __typename\n        ... on LearnAsyncContentTypeDefinition {\n          extension {\n            __typename\n            ... on LearnContentExtensionImpl {\n              isUnlockNecessaryToStart\n            }\n          }\n        }\n      }\n      structureDefinition {\n        __typename\n        ... on LearnOpportunityRootStructureDefinition {\n          progressPercentage\n          title\n          viewerTreeState {\n            __typename\n            kind\n            ... on IsStartedViewerTreeState {\n              startedAt\n              headContentId\n            }\n          }\n          extension {\n            __typename\n            ... on PublishedRootExtensionImpl {\n              unlockInfo {\n                __typename\n                kind\n                ... on UnlockInfoDemo {\n                  firstContentId\n                }\n              }\n              diploma\n              tags {\n                __typename\n                id\n                kind\n                data {\n                  name\n                  isClickable\n                  isTopic\n                }\n              }\n              product {\n                ...offerCard_ProductFragment\n                id\n              }\n              extension {\n                __typename\n                ... on PublishedConstellationRootExtensionExtension {\n                  isMicroLearning\n                  licenseAvailability {\n                    __typename\n                    ... on LicenseAvailabilityFreeLicensesAvailable {\n                      numAvailable\n                    }\n                  }\n                  contractPartner {\n                    id\n                    data {\n                      name\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ... on PublishedMicroLearningLearnable {\n    id\n    kind\n    root {\n      id\n      description\n      shortDescription\n      image {\n        url\n        id\n      }\n      typeDefinition {\n        __typename\n        ... on LearnAsyncContentTypeDefinition {\n          extension {\n            __typename\n            ... on LearnContentExtensionImpl {\n              isUnlockNecessaryToStart\n            }\n          }\n        }\n      }\n      structureDefinition {\n        __typename\n        ... on LearnOpportunityRootStructureDefinition {\n          progressPercentage\n          title\n          viewerTreeState {\n            __typename\n            kind\n            ... on IsStartedViewerTreeState {\n              headContentId\n              startedAt\n            }\n          }\n          extension {\n            __typename\n            ... on PublishedRootExtensionImpl {\n              unlockInfo {\n                __typename\n                kind\n                ... on UnlockInfoDemo {\n                  firstContentId\n                }\n              }\n              diploma\n              tags {\n                __typename\n                id\n                kind\n                data {\n                  name\n                  isClickable\n                  isTopic\n                }\n              }\n              product {\n                ...offerCard_ProductFragment\n                id\n              }\n              extension {\n                __typename\n                ... on PublishedConstellationRootExtensionExtension {\n                  isMicroLearning\n                  licenseAvailability {\n                    __typename\n                    ... on LicenseAvailabilityFreeLicensesAvailable {\n                      numAvailable\n                    }\n                  }\n                  contractPartner {\n                    id\n                    data {\n                      name\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment feedbackQuote_CustomerFeedbackQueryFragment on Trend {\n  customerData {\n    amountCustomer\n    customerFeedbacks {\n      feedback\n      id\n      name\n      position\n    }\n  }\n}\n\nfragment offerCard_ProductFragment on Product {\n  isTaxFree\n  netPrice\n  extensions {\n    __typename\n    kind\n    ... on AcademiesProductExtension {\n      deGrossPrice\n      atGrossPrice\n      chGrossPrice\n    }\n  }\n}\n\nfragment tags_AcademiesRooTagsConnectionFragment on Query {\n  AcademiesTag {\n    AcademiesTags {\n      edges {\n        node {\n          ...tags_AcademiesRootTagFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment tags_AcademiesRootTagFragment on AcademiesRootTag {\n  id\n  kind\n  canBeDeleted\n  data {\n    name\n    isClickable\n    isTopic\n  }\n  children {\n    edges {\n      node {\n        id\n        kind\n        data {\n          isTopic\n          isClickable\n          name\n        }\n        subId\n      }\n    }\n  }\n}\n\nfragment trendMedia_TrendMediaFragment on Trend {\n  trendData {\n    name\n    description\n    tags {\n      __typename\n      id\n    }\n  }\n  trendMedia {\n    __typename\n    file {\n      url\n      id\n    }\n    kind\n  }\n}\n\nfragment trendOfferSection_TrendOfferFragment on Trend {\n  aboutOffersHeadingAndDescription {\n    description\n    heading\n  }\n}\n\nfragment trendUspBoxes_TrendUspBoxesFragment on Trend {\n  trendData {\n    advantages {\n      heading\n      description\n      icon\n    }\n  }\n}\n\nfragment trendsDetail_LearnableFragment on PublishedLearnable {\n  __isPublishedLearnable: __typename\n  kind\n  id\n  ...coachingLearnableCard_PublishedLearnableFragment\n  ...educationalOfferCard_PublishedCourseLearnableFragment\n}\n\nfragment trendsDetail_QueryFragment_1Bmzm5 on Query {\n  node(id: $id) {\n    __typename\n    ... on Trend {\n      id\n      ...trendMedia_TrendMediaFragment\n      ...trendUspBoxes_TrendUspBoxesFragment\n      ...feedbackQuote_CustomerFeedbackQueryFragment\n      ...trendOfferSection_TrendOfferFragment\n      trendData {\n        name\n      }\n      potentialAnalysisHeadingAndDescription {\n        description\n        heading\n      }\n      coachingHeadingAndDescription {\n        description\n        heading\n      }\n      coachingImage {\n        url\n        id\n      }\n      learnables {\n        __typename\n        id\n        kind\n        ...trendsDetail_LearnableFragment\n      }\n    }\n    id\n  }\n  ...tags_AcademiesRooTagsConnectionFragment\n}\n"
  }
};
})();

(node as any).hash = "a92b8b7586f3acc1797a275eea0ee70b";

export default node;
